module.exports = __webpack_public_path__ + "static/media/se.7c8f633a.mp3";